import PropTypes from 'prop-types';

export const PropTypeStatusIsRequired = {
  status: PropTypes.shape({
    status: PropTypes.string,
  }).isRequired,
};

export default {
  status: PropTypes.shape({
    status: PropTypes.string,
  }),
};



// WEBPACK FOOTER //
// ./src/utilities/propTypes/PropTypeStatus.js